import React from "react";
import * as Mui from "@mui/material";
import { SettingsDialog } from "component/shared/settings-dialog";

interface Props {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export const RestoreDefaultsDialog: React.FC<Props> = ({ open, onClose, onConfirm }) => (
	<SettingsDialog
		open={open}
		title="Restore default recipients?"
		onClose={onClose}
		confirmLabel="Restore Defaults"
		onConfirm={onConfirm}
	>
		{/* Figma separates the two sentences by a blank line (24px), wider than the 16px body gap. */}
		<Mui.Typography style={{ whiteSpace: "pre-line" }}>
			{"This will reset all rows to Account Owner and Assigned Agent, removing any custom recipients you've added.\n\nThis can't be undone."}
		</Mui.Typography>
	</SettingsDialog>
);
